// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2PIoS","header":"MessagesList_header__2Hb6P","chat":"MessagesList_chat__1wCQ2"};